import { Routes } from "@angular/router";
import { CdiResolutionSummaryComponent } from "./cdi-resolution-summary/cdi-resolution-summary.component";
import { CdiComponent } from "./cdi.component";
import { CdiDispositionComponent } from "./cdi-disposition/cdi-disposition.component";

export const cdiRoutes: Routes = [
  { path: "", component: CdiComponent },
  {
    path: "cdi-resolution-summary/:id",
    component: CdiResolutionSummaryComponent,
  },
  {
    path: "cdi-disposition/:recId/:tableId",
    component: CdiDispositionComponent,
  },
];
